import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { TOOLTIP_STYLE, PANEL } from './chartTheme';

const shortDate = (d) => {
  const parts = d.split('-');
  return `${parts[2]}/${parts[1]}`;
};
const longDate = (d) => new Date(d).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });

export default function DailyViewsChart({ dailyViews }) {
  return (
    <div className={`lg:col-span-2 ${PANEL}`} data-testid="daily-views-chart">
      <h3 className="font-display text-sm font-bold text-earth-dark mb-4">Daily Page Views</h3>
      {dailyViews.length > 0 ? (
        <ResponsiveContainer width="100%" height={220}>
          <BarChart data={dailyViews} margin={{ top: 5, right: 5, left: -20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#F5E6CC" />
            <XAxis dataKey="date" tick={{ fontSize: 9, fill: '#8B7355' }} tickFormatter={shortDate} />
            <YAxis tick={{ fontSize: 9, fill: '#8B7355' }} allowDecimals={false} />
            <Tooltip contentStyle={TOOLTIP_STYLE} labelFormatter={longDate} />
            <Bar dataKey="views" fill="#D4870A" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <div className="h-[220px] flex items-center justify-center text-earth/30 font-sans text-sm">
          No data yet. Views will appear as visitors browse the site.
        </div>
      )}
    </div>
  );
}
